export class StoreConfig {
    id = null;
    code = null;
    name = null;
    storeType = null;
    applicableObject = null;
}